import Toast from '@tiger/toast';
import Loading from 'components/Loading'; // 导入你自己的Loading组件

Toast.config({
    Loading: ({ tip }) => <Loading tip={tip} />
});

export default Toast;
export * from '@tiger/toast';
